type PendingEvent = Record<string, unknown> & {eventId:string};
/** Persist confirmed commerce before sending; retries reuse the same idempotency key. */
export class EventDelivery {
  private pending: PendingEvent[]=[];
  private running=false;
  private retry?:ReturnType<typeof setTimeout>;
  private failures=0;
  constructor(private url:string,private headers:HeadersInit,private storageKey:string){
    try{const saved=JSON.parse(localStorage.getItem(storageKey)||'[]');if(Array.isArray(saved))this.pending=saved.filter(e=>e&&typeof e.eventId==='string'&&Date.parse(e.timestamp)>Date.now()-7*86400000).slice(-100);}catch{}
    window.addEventListener('online',()=>void this.flush());
    void this.flush();
  }
  async send(event:PendingEvent):Promise<void>{
    if(!this.pending.some(e=>e.eventId===event.eventId))this.pending.push(event);
    this.pending=this.pending.slice(-100);this.save();await this.flush();
  }
  private save(){try{localStorage.setItem(this.storageKey,JSON.stringify(this.pending));}catch{}}
  private async flush():Promise<void>{
    if(this.running||!this.pending.length)return;
    this.running=true;
    if(this.retry){clearTimeout(this.retry);this.retry=undefined;}
    try{while(this.pending.length){
      const event=this.pending[0]!;
      const response=await fetch(this.url,{method:'POST',headers:this.headers,keepalive:true,body:JSON.stringify({events:[event]})});
      if(!response.ok){
        // Invalid payloads cannot improve on retry; retain only transient failures.
        if(response.status===400||response.status===422){this.pending.shift();this.save();continue;}
        throw new Error(`tracking-${response.status}`);
      }
      this.pending.shift();this.failures=0;this.save();
    }}catch{this.failures++;this.retry=setTimeout(()=>void this.flush(),Math.min(60000,1000*2**Math.min(this.failures,6)));}
    finally{this.running=false;}
  }
}
